<template>
	<div>
		<vxe-modal size="mini" v-model="model" width="1200" height="800" :show-footer="true" destroy-on-close
			@show="show" @hide="hide" transfer :lock-scroll="false" :showHeader="true" :loading="loading" title="微信机器人">
			<template #default>
				<!-- 				<el-form ref="form" :inline="true" :model="form" label-width="80px">
					<el-form-item label="" label-width="0px">
						<el-input placeholder="请输入订单编码" v-model="form.ordercode">
							<el-button @click="autoSplitOrder" slot="append" icon="el-icon-search"></el-button>
						</el-input>
					</el-form-item>
				</el-form> -->

				<vxe-toolbar>
					<template #buttons>
						<vxe-form :data="form">
							<vxe-form-item title="群ID" field="id" :item-render="{}">
								<template #default="{ data }">
									<vxe-input v-model="data.id" placeholder="请输入" clearable
										@input="search"></vxe-input>
								</template>
							</vxe-form-item>
							<vxe-form-item title="群名称" field="topic" :item-render="{}">
								<template #default="{ data }">
									<vxe-input v-model="data.topic" placeholder="请输入" clearable
										@input="search"></vxe-input>
								</template>
							</vxe-form-item>
							<vxe-form-item title="供应商名称" field="suppliername" :item-render="{}">
								<template #default="{ data }">
									<vxe-input v-model="data.suppliername" placeholder="请输入" clearable
										@input="search"></vxe-input>
								</template>
							</vxe-form-item>


							<!-- 							<vxe-form-item title="供应商" field="supplierid" :item-render="{}">
								<template #default="{ data }">
									<el-select size="mini" v-model="data.supplierid" placeholder="" filterable clearable
										@change="search">
										<el-option v-for="(item,index) in supplierList" :key="index" :label="item.name"
											:value="item.id.toString()">
										</el-option>
									</el-select>

								</template>
							</vxe-form-item> -->
							<vxe-form-item title="类别" field="roomtype" :item-render="{}">
								<template #default="{ data }">
									<el-select size="mini" v-model="data.roomtype" placeholder="" filterable clearable
										@change="search">
										<el-option label="供应商" value="供应商"></el-option>
										<el-option label="快递" value="快递"></el-option>
										<el-option label="其他" value="其他"></el-option>
									</el-select>

								</template>
							</vxe-form-item>
						</vxe-form>
						<div>
							<vxe-button status="success" @click="add">新增</vxe-button>
							<vxe-button status="" @click="exportdata">导出</vxe-button>
							<vxe-button status="danger" @click="reset">刷新</vxe-button>
							<vxe-button status="primary" @click="sendtotal">群发</vxe-button>
						</div>
						<!-- <vxe-button status="primary" @click="friendship">申请好友</vxe-button> -->

					</template>
				</vxe-toolbar>
				<el-link type="danger">双击编辑：类别，仓库，供应商</el-link>
				<vxe-table ref="wechatyRoom" :expand-config="{lazy:true,loadMethod:loadMember,accordion:true}"
					height="600" resizable :data="roomList" :tooltip-config="{showAll:true}" :scroll-y="{enabled: true}"
					show-overflow :edit-config="{trigger: 'dblclick', mode: 'cell'}" border
					style="margin-bottom: 50px;">
					<vxe-column type="checkbox" width="50" fixed="left"></vxe-column>
					<!-- <vxe-column type="seq" width="50" ></vxe-column> -->
					<vxe-column field="id" width="120" title="群ID" fixed="left"></vxe-column>
					<!-- 					<vxe-column field="avatar" title="群头像">
						<template #default="{row}">
							<img :src="row.avatar" style="width: 50px;">
						</template>
					</vxe-column> -->
					<vxe-column field="topic" title="群名称" sortable width="220" :edit-render="{}">
						<template #edit="{row}">
							<el-input size="mini" v-model="row.topic" placeholder=""></el-input>
						</template>
						<template #default="{row}">
							<span>{{row.topic}}</span>
						</template>
					</vxe-column>
					<!-- <vxe-column field="supplier" title="绑定供应商" sortable></vxe-column> -->
					<vxe-column field="roomtype" title="类别" width="100" fixed="left" sortable :edit-render="{}">
						<template #edit="{row}">
							<el-select size="mini" v-model="row.roomtype" placeholder="" filterable clearable>
								<el-option label="供应商" value="供应商"></el-option>
								<el-option label="快递" value="快递"></el-option>
								<el-option label="其他" value="其他"></el-option>
							</el-select>
						</template>
						<template #default="{row}">
							<span>{{row.roomtype}}</span>
						</template>
					</vxe-column>
					<vxe-column field="warehouseid" title="仓库" width="200" sortable :edit-render="{}">
						<template #edit="{row}">
							<el-select size="mini" v-model="row.warehouseid" placeholder="" multiple filterable
								collapse-tags clearable @change="warehouseChange(row)">
								<el-option v-for="(item,index) in warehouseList" :key="index" :label="item.name"
									:value="item.id.toString()">
								</el-option>
							</el-select>
						</template>
						<template #default="{row}">
							<span>{{$systemMethods.getwarehouse(row.warehouseid)}}</span>
						</template>
					</vxe-column>
					<vxe-column field="supplierid" title="供应商" width="100" sortable :edit-render="{}">
						<template #edit="{row}">
							<el-select size="mini" v-model="row.supplierid" placeholder="" filterable clearable
								@change="supplierChange(row)">
								<el-option v-for="(item,index) in supplierList" :key="index" :label="item.name"
									:value="item.id.toString()">
								</el-option>
							</el-select>
						</template>
						<template #default="{row}">
							<span>{{$systemMethods.getsupplier(row.supplierid)}}</span>
						</template>
					</vxe-column>
					<vxe-column field="logistics" width="120" title="快递公司" sortable :edit-render="{}">
						<template #edit="{row}">
							<el-select size="mini" v-model="row.logistics" placeholder="" filterable clearable>
								<el-option label="顺丰" value="顺丰"></el-option>
								<el-option label="中通" value="中通"></el-option>
								<el-option label="圆通" value="圆通"></el-option>
								<el-option label="安能" value="安能"></el-option>
								<el-option label="德邦" value="德邦"></el-option>
								<el-option label="极兔" value="极兔"></el-option>
								<el-option label="申通" value="申通"></el-option>
								<el-option label="韵达" value="韵达"></el-option>
								<el-option label="邮政" value="邮政"></el-option>
								<el-option label="联昊通" value="联昊通"></el-option>
								<el-option label="加运美" value="加运美"></el-option>
							</el-select>
						</template>
						<template #default="{row}">
							<span>{{row.logistics}}</span>
						</template>
					</vxe-column>
					<vxe-column field="logisticsid" title="快递" width="200" sortable :edit-render="{}">
						<template #edit="{row}">
							<el-select size="mini" v-model="row.logisticsid" placeholder="" multiple filterable
								collapse-tags clearable @change="warehouseChange(row)">
								<el-option v-for="(item,index) in logisticsList" :key="index" :label="item.name"
									:value="item.id.toString()">
								</el-option>
							</el-select>
						</template>
						<template #default="{row}">
							<span>{{getlogistics(row.logisticsid)}}</span>
						</template>
					</vxe-column>
					<!-- 					<vxe-column type="expand" title="成员" width="50">
						<template #content>
							<div style="box-sizing: border-box;padding: 20px;">
								<vxe-table :data="memberList" height="400px">
									<vxe-column type="seq" width="60"></vxe-column>
									<vxe-column field="avatar" title="头像">
										<template #default="{row}">
											<img :src="row.avatar" style="width: 36px;">
										</template>
									</vxe-column>
									<vxe-column field="id" title="id"></vxe-column>
									<vxe-column field="name" title="名称"></vxe-column>
									<vxe-column title="操作" width="100" show-overflow>
										<template #default="{ row }">
											<vxe-button mode="text" size="mini" @click="sendOpen(row)"
												status="primary">发送</vxe-button>
										</template>
									</vxe-column>
								</vxe-table>
							</div>
						</template>
					</vxe-column> -->
					<vxe-column field="messagetype" title="消息类型" sortable :edit-render="{}" width="100" fixed="right">
						<template #edit="{row}">
							<el-select size="mini" v-model="row.messagetype" placeholder="" filterable clearable>
								<el-option label="所有" value="所有"></el-option>
								<el-option label="对账单" value="对账单"></el-option>
								<el-option label="提前揽收" value="提前揽收"></el-option>
<!-- 								<el-option label="应急" value="应急"></el-option>
								<el-option label="备货" value="备货"></el-option> -->
							</el-select>
						</template>
						<template #default="{row}">
							<span>{{row.messagetype}}</span>
						</template>
					</vxe-column>
					<vxe-column field="botmark" title="机器人备注" sortable :edit-render="{}" width="100"
						fixed="right">
						<template #edit="{row}">
							<el-input size="mini" v-model="row.botmark" placeholder="" ></el-input>
						</template>
						<template #default="{row}">
							<span>{{row.botmark}}</span>
						</template>						
					</vxe-column>
					<vxe-column title="操作" width="125" fixed="right" show-overflow align="center">
						<template #default="{ row }">
							<el-button size="mini" @click="save(row)" status="success" type="text"
								style="color: #67C23A;">保存</el-button>
							<el-button size="mini" @click="sendOpen(row)" status="primary" type="text">发送</el-button>
							<el-button size="mini" @click="mark(row)" status="" type="text">备注</el-button>
						</template>
					</vxe-column>



					<!-- 					<vxe-column field="storage_name" title="发货仓库"></vxe-column>
					<vxe-column field="address" title="省市区">
						<template #default="{row}">
							<span>{{row.tp_receiver_state+'/'+row.tp_receiver_city+'/'+row.tp_receiver_district}}</span>
						</template>
					</vxe-column>
					<vxe-column field="controll" title="操作推荐">
						<template #default="{row}">
							<span>{{row.controll.length==0?'无': row.controll.join('/')}}</span>
						</template>
					</vxe-column> -->
				</vxe-table>
			</template>
			<template #footer>
				<!-- <vxe-button size="mini" status="primary" content="提交任务" @click="submit(false)"></vxe-button> -->
			</template>
		</vxe-modal>

		<sendIndex :title="sendtitle" :row="currentRow" @sendover="sendover" ref="sendIndex" />

	</div>
</template>
<style scoped>

</style>
<script>
	import sendIndex from './send/index.vue'
	export default {
		props: {

		},
		data() {
			return {
				loading: false,
				model: true,
				form: {
					topic: '',
					supplierid: '',
					roomtype: '',
					suppliername: ''
				},
				logisticsList: [],
				warehouseList: window.systemData.warehouse,
				supplierList: window.systemData.supplier,
				roomList: [],
				sourceData: [],
				memberList: [],
				currentRow: null,
				sendtitle: '发送信息'
			}
		},
		created() {

		},
		mounted() {
			this.listlogistics()
			this.allRooms()

		},
		watch: {

		},
		computed: {

		},

		methods: {
			add(){
				this.$prompt('新增', '请输入群名', {
					confirmButtonText: '确定',
					cancelButtonText: '取消'
				}).then(({
					value
				}) => {
					//console.log(value)
					this.$api.wechaty.addgroup({
						roomname:value
					}).then(() => {
						this.$message.success('添加成功')
						this.allRooms()
					}, () => {
						
					})
					
				}).catch(() => {

				})
			},
			list(roomList) {
				this.$api.wechaty.list().then((res) => {
					roomList.forEach((item) => {
						let obj = res.find((_item) => {
							return _item.roomid == item.id
						})
						item.logistics = null
						item.warehouseid = null
						item.warehousewlnid = null
						item.supplierid = null
						item.suppliercode = null
						item.supplierwlnid = null
						item.roomtype = null
						if (obj) {
							item.logistics = obj.logistics
							item.warehouseid = obj.warehouseid ? obj.warehouseid.split(',') : null
							item.warehouseid = typeof(item.warehouseid) == 'string' ? [item.warehouseid] :
								item.warehouseid
							item.warehousewlnid = obj.warehousewlnid ? obj.warehousewlnid.split(',') : null
							item.warehousewlnid = typeof(item.warehousewlnid) == 'string' ? [item
								.warehousewlnid
							] : item.warehousewlnid

							item.logisticsid = obj.logisticsid ? obj.logisticsid.split(',') : null
							item.logisticsid = typeof(item.logisticsid) == 'string' ? [item.logisticsid] :
								item.logisticsid

							item.supplierid = obj.supplierid
							item.suppliername = obj.suppliername
							item.suppliercode = obj.suppliercode
							item.supplierwlnid = obj.supplierwlnid
							item.roomtype = obj.roomtype
							item.messagetype = obj.messagetype
						}
					})
					this.sourceData = JSON.parse(JSON.stringify(roomList))
					this.roomList = roomList

				})
			},
			listlogistics() {
				this.$api.parcel.list().then((res) => {
					this.logisticsList = res.map((item) => {
						return {
							id: item.unitUid,
							name: item.distrName
						}
					})
				})
			},
			getlogistics(logisticsid) {
				if (!logisticsid) {
					return logisticsid
				}
				let name = []
				logisticsid.forEach((item) => {
					let obj = this.logisticsList.find((_item) => {
						return _item.id == item
					})
					if (obj) {
						name.push(obj.name)
					} else {
						name.push(item)
					}

				})
				return name.join(',')
			},
			allRooms() {
				this.loading = true
				this.$api.wechaty.allRooms().then((res) => {
					this.loading = false
					res.forEach((item) => {
						item.type = 'room'
					})
					this.list(res)
				}, () => {
					this.loading = false
				})
			},
			mark(row) {
			
				// let roomList = this.roomList.filter((item)=>{
				// 	return item.roomtype == '供应商' && !item.botmark
				// })
				// roomList.forEach((item)=>{
				// 	let inputValue = item.suppliercode ?  (item.roomtype + '['+item.suppliercode+']') + '['+item.id.split('@')[0]+']' : null
				// 	inputValue = (!inputValue && item.botmark) ? item.botmark : inputValue
				// 	if(inputValue){
				// 		this.$api.wechaty.setmark({
				// 			roomid:item.id,
				// 			mark:inputValue,
				// 		}).then((res) => {
				// 			this.$message.success('已提交备注任务')
				// 		}, () => {
							
				// 		})
				// 	}
				// })
				
				//console.log(row)
				let roomtype = row.roomtype
				if(roomtype == '供应商'){
					roomtype = '供'
				}
				let inputValue = row.suppliercode ?  (roomtype + '['+row.suppliercode+']') + '['+row.id.split('@')[0]+']' : null
				inputValue = (!inputValue && row.botmark) ? row.botmark : inputValue
				this.$prompt('备注', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputValue: inputValue
				}).then(({
					value
				}) => {
					//console.log(value)
					this.$api.wechaty.setmark({
						roomid:row.id,
						mark:value,
					}).then(() => {
						this.$message.success('已提交备注任务')
					}, () => {
						
					})
					
				}).catch(() => {

				})
			},
			// allRooms() {
			// 	this.loading = true
			// 	fetch(window.config.wechaty + '/allRooms', {
			// 			method: 'POST',
			// 			headers: {
			// 				'Content-Type': 'application/json'
			// 			},
			// 			body: null
			// 		}).then((response) => response.text())
			// 		.then((data) => {
			// 			this.loading = false
			// 			let roomList = []
			// 			let res = JSON.parse(data)
			// 			if (res.code == 200) {
			// 				res.data.data.forEach((item) => {
			// 					item.payload.type = 'room'
			// 					roomList.push(item.payload)
			// 				})
			// 			}

			// 			this.list(roomList)
			// 		})
			// 		.catch(() => {
			// 			this.loading = false
			// 		});
			// },
			addfriendship(phone) {
				this.loading = true
				fetch(window.config.wechaty + '/friendship', {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json'
						},
						body: JSON.stringify({
							phone: phone
						})
					}).then((response) => response.text())
					.then((data) => {
						this.loading = false
						let res = JSON.parse(data)
						if (res.code == 200) {
							this.$message.success('发送成功')
						}
					})
					.catch(() => {
						this.$message.error('发送失败')
						this.loading = false
					});
			},
			loadMember({
				row
			}) {
				return new Promise(resolve => {
					fetch(window.config.wechaty + '/memberAll', {
							method: 'POST',
							headers: {
								'Content-Type': 'application/json'
							},
							body: JSON.stringify({
								id: row.id
							})
						}).then((response) => response.text())
						.then((data) => {
							this.memberList = []
							let res = JSON.parse(data)
							if (res.code == 200) {
								res.data.data.forEach((item) => {
									item.payload.topic = row.topic
									item.payload.roomid = row.id
									item.payload.type = 'member'
									this.memberList.push(item.payload)
								})
							}
							resolve()
						})
				})
			},
			fomattercontroll(controll) {
				if (controll == 0) {
					return '无'
				}
				if (controll == 1) {
					return '无'
				}
				if (controll == 2) {
					return '拆出改仓'
				}
			},
			show() {

			},
			hide() {
				this.$emit('hide')
			},
			submit() {

				this.$api.tool.saveSplitTrade({
					data: this.tableList
				}).then(() => {
					this.$message.success('操作成功')
				})
			},
			sendOpen(row) {
				if (Array.isArray(row)) {
					this.currentRow = row
					this.sendtitle = '群发'
				} else {
					this.currentRow = [row]
					if (row.type == 'room') {
						this.sendtitle = '发送对象：' + row.topic
					}
					if (row.type == 'member') {
						this.sendtitle = '发送对象：' + row.topic + '@' + row.name
					}
				}
				this.$refs.sendIndex.alert()

			},
			reset() {
				this.allRooms()

			},
			friendship() {
				this.$prompt('请输入手机号', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(({
					value
				}) => {
					this.addfriendship(value)
				}).catch(() => {

				});
			},
			search() {
				//console.log(this.sourceData)
				this.roomList = this.sourceData.filter((item) => {
					item.topic = item.topic ? item.topic : ''
					item.suppliername = item.suppliername ? item.suppliername : ''
					// item.supplierid = item.supplierid ? item.supplierid : ''
					item.roomtype = item.roomtype ? item.roomtype : ''
					return item.topic.includes(this.form.topic) &&
						item.suppliername.includes(this.form.suppliername) &&
						item.roomtype.includes(this.form.roomtype)
				})
				if (this.form.id) {
					this.roomList = this.roomList.filter((item) => {
						return this.form.id.includes(item.id)
					})
				}


			},
			exportdata() {
				this.loading = true
				this.$refs.wechatyRoom.exportData({
					filename: '供应商微信群',
					type: 'xlsx',
					data: this.roomList,
				}).then(() => {
					this.loading = false
				})
			},
			sendtotal() {
				let data = this.$refs.wechatyRoom.getCheckboxRecords()
				if (data.length == 0) {
					this.$message.error('请选择群')
					return
				}
				this.sendOpen(data)
			},
			sendover() {
				// if (e.errordata.length == 0) {
				// 	this.$message.success('发送成功')
				// } else {
				// 	this.form.topic = ''
				// 	let roomlist = []
				// 	this.sourceData.forEach((item) => {
				// 		let index = e.errordata.findIndex((indexitem) => {
				// 			return item.id == indexitem
				// 		})
				// 		if (index !== -1) {
				// 			roomlist.push(item)
				// 		}
				// 	})
				// 	this.$refs.wechatyRoom.reloadData(roomlist)
				// 	this.$message.error('部分发送成功，请重试')
				// }
			},
			supplierChange(row) {
				let obj = this.supplierList.find((item) => {
					return item.id == row.supplierid
				})
				if (obj) {
					row.supplierwlnid = obj.wlnid
				} else {
					row.supplierwlnid = null
				}
			},
			warehouseChange(row) {
				let warehousewlnids = []
				row.warehouseid.forEach((w) => {
					let obj = this.warehouseList.find((item) => {
						return item.id == w
					})
					if (obj) {
						warehousewlnids.push(obj.wlnid)

					}
				})
				row.warehousewlnid = warehousewlnids
			},
			logisticsChange(row) {
				let logisticsids = []
				row.logisticsid.forEach((w) => {
					let obj = this.logisticsList.find((item) => {
						return item.id == w
					})
					if (obj) {
						logisticsids.push(obj.unitUid)

					}
				})
				row.logisticsid = logisticsids
			},
			save(row) {
				//console.log(row)
				this.$api.wechaty.save({
					roomid: row.id,
					roomtype: row.roomtype,
					roomname: row.topic,
					supplierid: row.supplierid,
					supplierwlnid: row.supplierwlnid,
					warehouseid: row.warehouseid,
					warehousewlnid: row.warehousewlnid,
					logistics: row.logistics,
					logisticsid: row.logisticsid,
					messagetype: row.messagetype,
					botmark: row.botmark,
				}).then(() => {
					this.$message.success('保存成功')
				})

			}
		},
		components: {
			sendIndex
		}
	}
</script>